import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "action-make-helper",
  "use": "action-make-helper-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"feather feather-user-plus\" viewBox=\"0 0 24 24\" id=\"action-make-helper\"><path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\" /><circle cx=\"8.5\" cy=\"7\" r=\"4\" /><path d=\"M20 8v6M23 11h-6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol